import { getRequest } from '@bo-apis/axios';

const getLatestPrivacyPolicy = () =>
  getRequest({
    url: '/api/v1/co/system/privacy-policy',
  });

const coPrivacyPolicy = {
  getLatestPrivacyPolicy,
};

export default coPrivacyPolicy;
